import { db } from '../firebase/firebase';
//Actions

// db.collection('log').add({
//   action: 'elementary',
//   attempt: true,
//   clan: 'clan-milo',
//   clanAddress: 'Berlín 841',
//   clanName: 'Milo',
//   date: new Date(),
//   door: 'Entrada',
//   key: 'llave-test-place',
//   method: 'app',
//   place: 'test-place',
//   site: 'caseta-test-place',
//   user: 'user-ben',
//   userName: 'Ben Milo',
// });

// db.collection('log').add({
//   clan: 'clan-solo',
//   clanAddress: 'Jerez 420',
//   clanName: 'Solo',
//   date: new Date(),
//   door: 'Entrada',
//   gate: 0,
//   id: 345688,
//   method: 'tag',
//   place: 'test-place',
// });

export function logGet(method, clan) {
  return async (dispatch, getState) => {
    const place = getState().place.uid;
    const log = [];
    let logRef = db
      .collection('log')
      .where('place', '==', place)
      .where('method', '==', method)
      .orderBy('date', 'desc')
      .limit(2000);
    logRef = clan ? logRef.where('clan', '==', clan) : logRef;
    logRef.onSnapshot((querySnap) => {
      querySnap.docChanges().forEach(({ doc, type }) => {
        const data = doc.data();
        if (type === 'added') {
          log.push({
            ...data,
            date: data.date.seconds * 1000,
          });
        }
      });
      return dispatch(logSet(log, method));
    });
  };
}

export function logSet(log, method) {
  return {
    type: 'LOG_SET',
    log,
    method,
  };
}
